import { useLayoutEffect } from 'react';

/**
 * These stylesheets live in /public, so they are served from stable URLs with
 * a long max-age - a changed one keeps coming from the browser cache after a
 * deploy. The bundle's own filename carries a content hash that changes with
 * every build, so tagging the href with it retires the cached copy exactly
 * when a new build goes out. In development the bundle is unhashed, there is
 * no tag, and the dev server sends no-cache anyway.
 */
const buildTag = (() => {
  if (typeof document === 'undefined') return '';
  const script = document.querySelector('script[src*="/static/js/main."]');
  const match = script && script.src.match(/main\.([a-z0-9]+)\.js/i);
  return match ? match[1] : '';
})();

/**
 * Loads a stylesheet from /public for as long as the calling page is mounted.
 *
 * The landing pages under public/eyes are ports of standalone HTML documents:
 * their CSS styles bare `body`, `nav`, `section`, `h1`… selectors and would
 * bleed into the rest of the app if it were bundled through an `import`.
 * Attaching it here keeps it scoped to the route's lifetime instead.
 */
export default function usePageStylesheet(href) {
  useLayoutEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = buildTag ? `${href}?v=${buildTag}` : href;
    document.head.appendChild(link);
    return () => link.remove();
  }, [href]);
}
